module.exports = __webpack_public_path__ + "static/media/7.3d3cc637.png";